var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value != undefined && _vm.currency)?_c('span',[_vm._v(_vm._s(_vm.$n(_vm.value, { style: "currency", currency: _vm.currency, currencyDisplay: "code", })))]):(_vm.currency)?_c('span',[_vm._v(_vm._s(_vm.currency))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }